import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useRealmApp } from "../RealmApp";

const useRooms = () => {
  const app = useRealmApp();
  const { rooms, loading } = useAllRooms(app.currentUser.id);
  return {
    loading,
    rooms,
  };
};

export default useRooms;

function useAllRooms(ownerId) {
  //
  const { data, loading, error } = useQuery(
    gql`
      query getRooms($ownerId: String!) {
        rooms(query: { owner_id: $ownerId }, limit: 0) {
          _id
          storeId
          name
          width
          height
          virtual
          priceIncrement
          priceLists
          updateDatetime
          creationDatetime
          tables {
            _id
            name
            type
            color
            capacity
            posX
            posY
            width
            height
          }
          decorations {
            _id
            name
            type
            color
            posX
            posY
            width
            height
          }
        }
      }
    `,
    { variables: { ownerId } }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const rooms = data?.rooms ?? [];
  return { rooms, loading };
}
